import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../../../components/navbar';
import Footer from '../../../../components/footer';
import Button from '../../../../components/Button';
import { useConsultation } from '../../../../context/ConsultationContext';
import { handleTreatmentServiceNavigation } from '../components/treatmentNavigationHelper';
import baseStyles from './css/BloodPressure.module.css';
import styles from './css/EarSyringing.module.css';
import { Ear, Send } from 'lucide-react';
import Dropdown from '../../../../components/Dropdown';

const EarSyringing = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { consultationData, updateConsultationData, getStepDraft, setStepDraft, goToStep } = useConsultation();

    const patient = location?.state?.patient || consultationData?.patient || {};
    const patientName = `${patient?.firstname || ""} ${patient?.surname || ""}`.trim() || "Thandiwe Ndlovu";
    const profileNumber = patient?.profilenumber || "448896";
    const initials = `${patient?.firstname?.[0] || ""}${patient?.surname?.[0] || ""}`.toUpperCase() || "TN";

    const [earAffected, setEarAffected] = useState('left');
    const [painPresent, setPainPresent] = useState(false);
    const [dischargePresent, setDischargePresent] = useState(false);
    const [outcome, setOutcome] = useState('');
    const [clinicalNotes, setClinicalNotes] = useState('');

    useEffect(() => {
        document.body.classList.add(baseStyles.hideSidebar);
        return () => {
            document.body.classList.remove(baseStyles.hideSidebar);
        };
    }, []);

    const handleInvoice = () => {
        handleTreatmentServiceNavigation({
            location,
            navigate,
            consultationData,
            updateConsultationData,
            getStepDraft,
            setStepDraft,
            goToStep,
            serviceData: {
                ear_syringing: {
                    earAffected,
                    painPresent,
                    dischargePresent,
                    outcome,
                    clinicalNotes,
                },
            },
        });
    };

    return (
        <div className={baseStyles.bloodPressureContainer}>
            <Navbar />

            <main className={baseStyles.mainContent}>
                <div className={baseStyles.card}>
                    <div className={baseStyles.cardHeader}>
                        <div className={baseStyles.headerIcon} aria-hidden="true">
                            <Ear />
                        </div>
                        <h1 className={styles.title}>Ear Syringing</h1>
                    </div>

                    <div className={baseStyles.patientCard}>
                        <div className={baseStyles.avatar} aria-hidden="true">{initials}</div>
                        <div className={baseStyles.patientText}>
                            <div className={baseStyles.patientName}>{patientName}</div>
                            <div className={baseStyles.patientMetaRow}>
                                <span className={baseStyles.profileInfo}>Profile: {profileNumber}</span>
                                <span className={baseStyles.dependentBadge}>Dependent</span>
                            </div>
                        </div>
                    </div>

                    <div className={baseStyles.sectionBlock}>
                        <div className={baseStyles.sectionTitle}>PROCEDURE DETAILS</div>

                        <div className={styles.testTypeRow}>
                            <div className={styles.testTypeLabel}>Ear Affected</div>
                            <div className={styles.testTypeOptions}>
                                <button
                                    type="button"
                                    className={`${styles.testTypeButton} ${earAffected === 'left' ? styles.active : ''}`}
                                    onClick={() => setEarAffected('left')}
                                >
                                    Left
                                </button>
                                <button
                                    type="button"
                                    className={`${styles.testTypeButton} ${earAffected === 'right' ? styles.active : ''}`}
                                    onClick={() => setEarAffected('right')}
                                >
                                    Right
                                </button>
                                <button
                                    type="button"
                                    className={`${styles.testTypeButton} ${earAffected === 'both' ? styles.active : ''}`}
                                    onClick={() => setEarAffected('both')}
                                >
                                    Both
                                </button>
                            </div>
                        </div>

                        <div className={baseStyles.toggleSection}>
                            <label className={baseStyles.toggleLabel}>Pain Present</label>
                            <button
                                type="button"
                                className={`${baseStyles.toggleButton} ${painPresent ? baseStyles.active : ''}`}
                                onClick={() => setPainPresent(!painPresent)}
                                aria-pressed={painPresent}
                            >
                                <div className={baseStyles.toggleSlider}></div>
                            </button>
                        </div>

                        <div className={styles.toggleSection}>
                            <label className={baseStyles.toggleLabel}>Discharge Present</label>
                            <button
                                type="button"
                                className={`${baseStyles.toggleButton} ${dischargePresent ? baseStyles.active : ''}`}
                                onClick={() => setDischargePresent(!dischargePresent)}
                                aria-pressed={dischargePresent}
                            >
                                <div className={baseStyles.toggleSlider}></div>
                            </button>
                        </div>
                    </div>

                    <div className={baseStyles.sectionBlock}>
                        <div className={baseStyles.fieldLabel}>Outcome</div>
                        <Dropdown
                            name="outcome"
                            value={outcome}
                            onChange={setOutcome}
                            options={['Successful', 'Partially Successful', 'Unsuccessful', 'Referral Required']}
                            placeholder="Select..."
                            className={styles.readingInput}
                        />
                    </div>

                    <div className={baseStyles.sectionBlock}>
                        <div className={baseStyles.fieldLabel}>Clinical Notes</div>
                        <textarea
                            value={clinicalNotes}
                            onChange={(e) => setClinicalNotes(e.target.value)}
                            className={baseStyles.clinicalNotes}
                            placeholder="Enter clinical notes..."
                            rows={6}
                        />
                    </div>

                    <div className={baseStyles.cardFooter}>
                        <Button
                            onClick={handleInvoice}
                            className={baseStyles.invoiceButton}
                            type="button"
                        >
                            <Send size={16} />
                            Invoice
                        </Button>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default EarSyringing;